export default __webpack_public_path__ + "assets/6ecf57e77fdc065c2e33b2d38a7badde.jpg";